export default __webpack_public_path__ + "static/media/sevenIconRight.6ca2680e.svg";